import React, { useEffect, useRef } from 'react';
import tippy, { Instance, Props } from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/shift-away.css';

interface TooltipProps {
    content: React.ReactNode;
    children: React.ReactNode;
    placement?: Props['placement'];
    delay?: number;
}

export const Tooltip: React.FC<TooltipProps> = ({
    content,
    children,
    placement = 'top',
    delay = 200
}) => {
    const childRef = useRef<HTMLSpanElement>(null);
    const instanceRef = useRef<Instance | null>(null);
    const stringContent = typeof content === 'string' || typeof content === 'number'
        ? String(content)
        : undefined;

    useEffect(() => {
        if (childRef.current) {
            instanceRef.current = tippy(childRef.current, {
                content: content as string | Element, // Type assertion for simple string content
                placement,
                delay: [delay, 0],
                animation: 'shift-away',
                theme: 'translucent', // Could define custom theme in CSS
                arrow: true,
            });
        }

        return () => {
            instanceRef.current?.destroy();
        };
    }, [content, placement, delay]);

    return (
        <span className="inline-flex" data-tooltip-content={stringContent} ref={childRef}>
            {children}
        </span>
    );
};














